import React from 'react';

function LogicChallengeRun() {
  return <div>LogicChallengeRun</div>;
}

export default LogicChallengeRun;
